export default __webpack_public_path__ + "static/media/event1.3faa5d23.jpg";